import Spinner, { IProps, Size, Color } from './Spinner';
import spinnerStyles from './spinner.module.scss';

export type { IProps as ISpinnerProps, Size as SpinnerSize, Color as SpinnerColor };
export { Spinner, spinnerStyles };

export default Spinner;
